import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompleted = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 4C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4m-4 30L10 24l2.82-2.82L20 28.34l15.18-15.18L38 16z" })
});
export default SvgCompleted;
